import React, { useContext, useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { AppBar, Card, CardHeader, Stack, Tab, Tabs } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import UserDetailsContext, { useUserDetails } from "../../context/auth";
import MaterialDataGrid from "../../components/MaterialDataGrid";

import { useNavigate } from "react-router-dom";
// import "./perfomance.css";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";

import BASEURL from "../Utils/Baseurl";

import axios from "axios";
import MaterialBox from "../../components/MaterialBox";

const TaskAllocation = () => {
  const data = sessionStorage.getItem("user");
  const parsedData = JSON.parse(data);
  console.log("parsedData:", parsedData);
  const userid = parsedData?.id;
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [tabValue, setTabValue] = useState("MyTask");

  console.log(tabValue,"tabValue");
  
useEffect(() => {
    const tabName = JSON.parse(sessionStorage.getItem("taskTab"));

if(tabName){
  setTabValue(tabName);
}else{
  setTabValue("MyTask");
}
  }, [])
  const [TaskList, setTaskList] = useState([]);
  const navigate = useNavigate();

  const { user, AccessData } = useUserDetails();

  const onTaskclick = (e) => {
    if(tabValue!="MyTask"){
      sessionStorage.removeItem("mytask")
    }
    if (e?.id) {
      navigate(`/task-allocation/add-task?id=${e?.id}`);
    }
  };

  const [column, setcolumn] = useState([
    {
      field: "sno",
      headerName: "S.NO",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "project",
      headerName: "Project",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "title",
      headerName: "Title",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "dueDate",
      headerName: "DueDate",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "priorityLevel",
      headerName: "PriorityLevel",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    
    {
      field: "assignto",
      headerName: "Assign To",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "status",
      headerName: "status",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    // {
    //   field: "duration",
    //   headerName: "Duration",
    //   flex: 1,
    //   disableColumnMenu: true,
    //   editable: false,
    //   sortable: true,
    // },
    // {
    //   headerName: "Action",
    //   field: "action",
    //   name: "Action",
    //   flex: 1,
    //   disableColumnMenu: true,
    //   editable: false,
    // },
  ]);

  useEffect(() => {
    fetchtasklist(tabValue);

    sessionStorage.setItem("taskTab", JSON.stringify(tabValue));


    if(tabValue=="MyTask"){
              setcolumn([   {
      field: "sno",
      headerName: "S.NO",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "project",
      headerName: "Project",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "title",
      headerName: "Title",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "dueDate",
      headerName: "DueDate",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "priorityLevel",
      headerName: "PriorityLevel",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    
    {
      field: "assignby",
      headerName: "Assign By",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "status",
      headerName: "status",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },])
    }
    else{
              setcolumn([   {
      field: "sno",
      headerName: "S.NO",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "project",
      headerName: "Project",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "title",
      headerName: "Title",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "dueDate",
      headerName: "DueDate",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "priorityLevel",
      headerName: "PriorityLevel",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    
    {
      field: "assignto",
      headerName: "Assign to",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "status",
      headerName: "status",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },])
    }
    
  }, [tabValue]);

  const fetchtasklist = async (value = "Mylist") => {
    const mylist = `
       query TasksByUser($userId: Int!) {
  tasksByUser(userId: $userId) {
    id
    title
    description
    status
    priorityLevel
    estimatedHours
    completedHours
    dueDate
    startDate
    completedAt
    createdAt
    updatedAt
    statusDisplay
    priorityLevelDisplay
     project {
            title
        }
               assignedBy {
            firstName
        }
  }
}

       `;

    const teamlist = `
       query{
  allTasks{
    id
        title
        description
        status
        estimatedHours
        completedHours
        dueDate
        startDate
        completedAt
        createdAt
         priorityLevel
        updatedAt
        statusDisplay
        priorityLevelDisplay
    project{
      title
    }
       assignedBy {
            firstName
        }
    attachments{
      file
    }
  }
}
       `;
    
       const mytask =`
       
       query TasksAssignedToUser($assignedById: Int!) {
  tasksAssignedToUser(assignedById: $assignedById) {
    id
    title
    description
    status
    priorityLevel
    estimatedHours
    completedHours
    dueDate
    startDate
    completedAt
    createdAt
    updatedAt
    statusDisplay
    priorityLevelDisplay
    project {
      title
    }
    createdBy {
      firstName
    }
  }
}

       
       
       
       `

    try {
      const res = await axios.post(BASEURL, {
        query: value == "Mylist" ? mylist : value =="MyTask"?mytask:teamlist,
        variables: value == "Mylist" ? { userId: userid } : value =="MyTask"?{assignedById:userid}:{},
      });
      let row = [];
      if (value == "Mylist") {
        console.log(res, "Allres");
        row = res.data.data.tasksByUser.map((task, index) => ({
          sno: index + 1,
          id: task?.id,
          project: task?.project?.title,
          assignto:task.assignedBy?.firstName,
          title: task?.title,
          dueDate: task?.dueDate,
          priorityLevel: task?.priorityLevel,
          status: task?.status,
        }));


      }
      else if(value=="MyTask"){

        sessionStorage.setItem("mytask","mytask")

         row = res.data.data.tasksAssignedToUser.map((task, index) => ({
          sno: index + 1,
          id: task?.id,
          project: task?.project?.title,
          assignto:task.assignedBy?.firstName,
          title: task?.title,
          dueDate: task?.dueDate,
          assignby:task?.createdBy?.firstName,
          priorityLevel: task?.priorityLevel,
          status: task?.status,
        }));
      }
      
      else {
        row = res.data.data.allTasks.map((task, index) => ({
          sno: index + 1,
          id: task?.id,
          project: task?.project?.title,
          assignto:task.assignedBy?.firstName,
          title: task?.title,
          dueDate: task?.dueDate,
          priorityLevel: task?.priorityLevel,
          status: task?.status,
        }));
      }

      setTaskList(row);
      console.log(res, "tasklist");
    } catch (err) {
      console.log(err);
    }
  };

  const handleNewEvaluation = () => {
     sessionStorage.removeItem("mytask")
    navigate(`/task-allocation/add-task`);
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0} sx={{ width: "20%" }}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Task List
                </MaterialTypography>
              </Stack>

              {/* { role?.toLowerCase() == "manager" && (
  <MaterialSelect
    name="selecthr"
    value={selectHr}
    onChange={(e) => handleSelectHrChange(e)}
    options={selecthrOption2?.map((value) => ({
      value: value,
      label: value,
    }))}
  />
)} */}

              <MaterialBox width="80%">
                <AppBar position="static">
                  <Tabs
                    orientation={tabsOrientation}
                    value={tabValue}
                    onChange={(_, val) => setTabValue(val)}
                    sx={{
                      backgroundColor: "#f8f9fa", // Light background
                      borderRadius: "12px",
                      padding: "5px",
                    }}
                  >
                    {AccessData &&
                      Array.isArray(AccessData) &&
                      AccessData.some(
                        (item) =>
                          item.component === "AllTask" && item.can_access
                      ) && 
                      
                             (
                        <Tab
                          label="All Task"
                          value="team"
                          sx={{
                            transition: "0.3s",
                            "&:hover": {
                              backgroundColor: "#e5e8ec",
                              color: "#fff",
                              borderRadius: "8px",
                            },
                          }}
                        />
                             )
                            }
                        
                    {AccessData &&
                      Array.isArray(AccessData) &&
                      AccessData.some(
                        (item) =>
                          item.component === "SelfAssigned" && item.can_access
                      ) && (


                        <Tab
                          label="Self-assigned"
                          value="Mylist"
                          sx={{
                            color: "#2c5da8",
                            transition: "0.3s",
                            "&:hover": {
                              backgroundColor: "#e5e8ec",
                              color: "#1348a5",
                              borderRadius: "8px",
                            },
                          }}
                        />
                      )} 


                       <Tab
                          label="MyTask"
                          value="MyTask"
                          sx={{
                            color: "#2c5da8",
                            transition: "0.3s",
                            "&:hover": {
                              backgroundColor: "#e5e8ec",
                              color: "#1348a5",
                              borderRadius: "8px",
                            },
                          }}
                        />
                  </Tabs>
                </AppBar>
              </MaterialBox>

              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "SelfAssigned" && item.can_access ||  item.component === "AllTask" && item.can_access 
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewEvaluation()}
                  >
                    Task
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={TaskList}
          customHeight={550}
          columns={column}
          checkboxSelection={false}
          isSelectable={false}
          loading={pageState.loading}
          onRowClick={onTaskclick}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                No Task found
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default TaskAllocation;
